/**
 * The frozen 24-slot equipment set the Star Force section renders a stepper for (WP7 spec: "pick
 * the canonical set and freeze it in one shared constant"). Mirrors
 * `backend/.../goals/GearSlots.java` — kept in sync by hand since the two languages can't share a
 * literal source; `gear_star.slot_key` has no DB-level CHECK (see the V6 migration), so this list
 * is the only place a slot key is defined for the frontend.
 */
export interface GearSlot {
  key: string;
  label: string;
}

export const GEAR_SLOTS: readonly GearSlot[] = [
  { key: 'hat', label: 'Hat' },
  { key: 'top', label: 'Top' },
  { key: 'bottom', label: 'Bottom' },
  { key: 'overall', label: 'Overall' },
  { key: 'shoes', label: 'Shoes' },
  { key: 'gloves', label: 'Gloves' },
  { key: 'cape', label: 'Cape' },
  { key: 'shoulder', label: 'Shoulder' },
  { key: 'belt', label: 'Belt' },
  { key: 'weapon', label: 'Weapon' },
  { key: 'secondary', label: 'Secondary' },
  { key: 'emblem', label: 'Emblem' },
  { key: 'ring1', label: 'Ring 1' },
  { key: 'ring2', label: 'Ring 2' },
  { key: 'ring3', label: 'Ring 3' },
  { key: 'ring4', label: 'Ring 4' },
  { key: 'pendant1', label: 'Pendant 1' },
  { key: 'pendant2', label: 'Pendant 2' },
  { key: 'earrings', label: 'Earrings' },
  { key: 'face', label: 'Face accessory' },
  { key: 'eye', label: 'Eye accessory' },
  { key: 'heart', label: 'Heart' },
  { key: 'badge', label: 'Badge' },
  { key: 'pocket', label: 'Pocket' },
];
